import { render, staticRenderFns } from "./LoRaWANSettings.vue?vue&type=template&id=2fb6f651&scoped=true&"
import script from "./LoRaWANSettings.vue?vue&type=script&lang=ts&"
export * from "./LoRaWANSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb6f651",
  null
  
)

export default component.exports